<div class="bg-image"></div>
<div class="row col-12 justify-content-center">
    <div class="row col-12 login-block">
        <div class="col-12 col-lg-6">
            <div class="col-12 text-center">
                <img src="assets/img/UnityC_RGB_app_72ppi.jpg" class="img-fluid" alt="UnityC Logo">
            </div>
            <div class="row col-12 padding-top-20 d-none d-lg-block login-page-text">
                <div>
                    <span class="primary">C</span>onnect
                    <span class="padding-left-10 padding-right-10">|</span>
                    <span class="primary">C</span>ollaborate
                    <span class="padding-left-10 padding-right-10">|</span>
                    <span class="primary">C</span>ommunity
                </div>
                <div class="padding-top-20 primary">
                    Your Secure Connection to Canadian Law Offices
                </div>
            </div>

        </div>
        <div class="col-12 col-lg-6">
            <div class="login-card">

                <header *ngIf="!emailConfirmationSent"><span>{{isResetPassword() ? 'Reset' : 'Forgot'}} </span>Password</header>

                <ng-container *ngIf="emailConfirmationSent">
                    <div>
                        <div>
                            <mat-label>{{resetLinkSent}}</mat-label>
                        </div>
                        <div>
                            <mat-label>{{resetLinkSent2}}</mat-label>
                        </div>
                    </div>
                </ng-container>
                <form [formGroup]="formGroup" *ngIf="!emailConfirmationSent">
                    <div>
                        <mat-form-field appearance="legacy"  >
                            <mat-label>Email</mat-label>
                            <input matInput formControlName="loginId" required autocomplete="off" my-auto-focus>
                            <mat-error *ngIf="formGroup.controls?.loginId?.errors?.required">Email is required</mat-error>
                            <mat-error *ngIf="formGroup.controls?.loginId?.errors?.email">Email must be a valid email address</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="login-btn padding-top-20">
                        <button class="bold-font col-12" mat-raised-button color="accent" (click)="submit()" >
                            NEXT
                        </button>
                    </div>
                </form>
                <div class="text-center padding-top-20">
                    <a [routerLink]="['/login']">Back to login page</a>
                </div>
            </div>

        </div>
    </div>
    <div  class="footer-block d-none d-lg-block justify-content-lg-center">
        <dp-footer></dp-footer>
    </div>
</div>
